"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * AAS Template repository API
 * The API implemented by the AAS repository
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatesApi = exports.TemplatesApiFactory = exports.TemplatesApiFp = exports.TemplatesApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
const common_1 = require("../common");
const base_1 = require("../base");
/**
 * TemplatesApi - axios parameter creator
 * @export
 */
const TemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Deletes the AAS template with the given hash.
         * @param {string} templateHash
         * @param {string} [revision]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate: async (templateHash, revision, options = {}) => {
            // verify required parameter 'templateHash' is not null or undefined
            common_1.assertParamExists('deleteTemplate', 'templateHash', templateHash);
            const localVarPath = `/template/aas/{templateHash}`
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            if (revision !== undefined) {
                localVarQueryParameter['revision'] = revision;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve multiple i4.0 References at once with the backend. The result will be in the same order as supplied in the request body.
         * @param {Array<Reference>} reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveReferences: async (reference, options = {}) => {
            // verify required parameter 'reference' is not null or undefined
            common_1.assertParamExists('resolveReferences', 'reference', reference);
            const localVarPath = `/template/reference/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(reference, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the processing state of uploaded templates (descending order w.r.t. uploadedOn).
         * @param {string} [userId] Get template processing states for userId
         * @param {number} [limit] Retrieve only the last X states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllProcessingStates: async (userId, limit, options = {}) => {
            const localVarPath = `/templates/processing/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the I4.0 AAS template with the given hash
         * @param {string} templateHash
         * @param {string} [revision]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplate: async (templateHash, revision, options = {}) => {
            // verify required parameter 'templateHash' is not null or undefined
            common_1.assertParamExists('retrieveTemplate', 'templateHash', templateHash);
            const localVarPath = `/template/aas/{templateHash}`
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            if (revision !== undefined) {
                localVarQueryParameter['revision'] = revision;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all submodels for a given I4.0 AAS template.
         * @param {string} templateHash
         * @param {string} [revision]
         * @param {string} [submodelIdShort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplateSubmodels: async (templateHash, revision, submodelIdShort, options = {}) => {
            // verify required parameter 'templateHash' is not null or undefined
            common_1.assertParamExists('retrieveTemplateSubmodels', 'templateHash', templateHash);
            const localVarPath = `/template/aas/{templateHash}/submodels`
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            if (revision !== undefined) {
                localVarQueryParameter['revision'] = revision;
            }
            if (submodelIdShort !== undefined) {
                localVarQueryParameter['submodelIdShort'] = submodelIdShort;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update template and/or the metadata for the given hash.
         * @param {string} templateHash
         * @param {string} revision Revision of the new template file
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateFile: async (templateHash, revision, file, options = {}) => {
            // verify required parameter 'templateHash' is not null or undefined
            common_1.assertParamExists('updateTemplateFile', 'templateHash', templateHash);
            // verify required parameter 'revision' is not null or undefined
            common_1.assertParamExists('updateTemplateFile', 'revision', revision);
            // verify required parameter 'file' is not null or undefined
            common_1.assertParamExists('updateTemplateFile', 'file', file);
            const localVarPath = `/template/aas/{templateHash}/file`
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session-user required
            if (revision !== undefined) {
                localVarFormParams.append('revision', revision);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update template and/or the metadata for the given hash.
         * @param {string} templateHash
         * @param {TemplateMetadataUpdate} [metadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateMetadata: async (templateHash, metadata, options = {}) => {
            // verify required parameter 'templateHash' is not null or undefined
            common_1.assertParamExists('updateTemplateMetadata', 'templateHash', templateHash);
            const localVarPath = `/template/aas/{templateHash}/metadata`
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session-user required
            if (metadata !== undefined) {
                localVarFormParams.append('metadata', new Blob([JSON.stringify(metadata)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a new template along with its metadata.
         * @param {TemplateMetadata} metadata
         * @param {string} revision Revision of the template
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNewTemplateAndMetadata: async (metadata, revision, file, options = {}) => {
            // verify required parameter 'metadata' is not null or undefined
            common_1.assertParamExists('uploadNewTemplateAndMetadata', 'metadata', metadata);
            // verify required parameter 'revision' is not null or undefined
            common_1.assertParamExists('uploadNewTemplateAndMetadata', 'revision', revision);
            // verify required parameter 'file' is not null or undefined
            common_1.assertParamExists('uploadNewTemplateAndMetadata', 'file', file);
            const localVarPath = `/template/aas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication session-user required
            if (metadata !== undefined) {
                localVarFormParams.append('metadata', new Blob([JSON.stringify(metadata)], { type: "application/json", }));
            }
            if (revision !== undefined) {
                localVarFormParams.append('revision', revision);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TemplatesApiAxiosParamCreator = TemplatesApiAxiosParamCreator;
/**
 * TemplatesApi - functional programming interface
 * @export
 */
const TemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         * Deletes the AAS template with the given hash.
         * @param {string} templateHash
         * @param {string} [revision]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplate(templateHash, revision, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplate(templateHash, revision, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Resolve multiple i4.0 References at once with the backend. The result will be in the same order as supplied in the request body.
         * @param {Array<Reference>} reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveReferences(reference, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveReferences(reference, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieves the processing state of uploaded templates (descending order w.r.t. uploadedOn).
         * @param {string} [userId] Get template processing states for userId
         * @param {number} [limit] Retrieve only the last X states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAllProcessingStates(userId, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAllProcessingStates(userId, limit, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieves the I4.0 AAS template with the given hash
         * @param {string} templateHash
         * @param {string} [revision]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTemplate(templateHash, revision, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTemplate(templateHash, revision, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieves all submodels for a given I4.0 AAS template.
         * @param {string} templateHash
         * @param {string} [revision]
         * @param {string} [submodelIdShort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTemplateSubmodels(templateHash, revision, submodelIdShort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTemplateSubmodels(templateHash, revision, submodelIdShort, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Update template and/or the metadata for the given hash.
         * @param {string} templateHash
         * @param {string} revision Revision of the new template file
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplateFile(templateHash, revision, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplateFile(templateHash, revision, file, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Update template and/or the metadata for the given hash.
         * @param {string} templateHash
         * @param {TemplateMetadataUpdate} [metadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplateMetadata(templateHash, metadata, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplateMetadata(templateHash, metadata, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Upload a new template along with its metadata.
         * @param {TemplateMetadata} metadata
         * @param {string} revision Revision of the template
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadNewTemplateAndMetadata(metadata, revision, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadNewTemplateAndMetadata(metadata, revision, file, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.TemplatesApiFp = TemplatesApiFp;
/**
 * TemplatesApi - factory interface
 * @export
 */
const TemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TemplatesApiFp(configuration);
    return {
        /**
         * Deletes the AAS template with the given hash.
         * @param {string} templateHash
         * @param {string} [revision]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate(templateHash, revision, options) {
            return localVarFp.deleteTemplate(templateHash, revision, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve multiple i4.0 References at once with the backend. The result will be in the same order as supplied in the request body.
         * @param {Array<Reference>} reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveReferences(reference, options) {
            return localVarFp.resolveReferences(reference, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the processing state of uploaded templates (descending order w.r.t. uploadedOn).
         * @param {string} [userId] Get template processing states for userId
         * @param {number} [limit] Retrieve only the last X states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllProcessingStates(userId, limit, options) {
            return localVarFp.retrieveAllProcessingStates(userId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the I4.0 AAS template with the given hash
         * @param {string} templateHash
         * @param {string} [revision]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplate(templateHash, revision, options) {
            return localVarFp.retrieveTemplate(templateHash, revision, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all submodels for a given I4.0 AAS template.
         * @param {string} templateHash
         * @param {string} [revision]
         * @param {string} [submodelIdShort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplateSubmodels(templateHash, revision, submodelIdShort, options) {
            return localVarFp.retrieveTemplateSubmodels(templateHash, revision, submodelIdShort, options).then((request) => request(axios, basePath));
        },
        /**
         * Update template and/or the metadata for the given hash.
         * @param {string} templateHash
         * @param {string} revision Revision of the new template file
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateFile(templateHash, revision, file, options) {
            return localVarFp.updateTemplateFile(templateHash, revision, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Update template and/or the metadata for the given hash.
         * @param {string} templateHash
         * @param {TemplateMetadataUpdate} [metadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateMetadata(templateHash, metadata, options) {
            return localVarFp.updateTemplateMetadata(templateHash, metadata, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a new template along with its metadata.
         * @param {TemplateMetadata} metadata
         * @param {string} revision Revision of the template
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNewTemplateAndMetadata(metadata, revision, file, options) {
            return localVarFp.uploadNewTemplateAndMetadata(metadata, revision, file, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TemplatesApiFactory = TemplatesApiFactory;
/**
 * TemplatesApi - object-oriented interface
 * @export
 * @class TemplatesApi
 * @extends {BaseAPI}
 */
class TemplatesApi extends base_1.BaseAPI {
    /**
     * Deletes the AAS template with the given hash.
     * @param {string} templateHash
     * @param {string} [revision]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    deleteTemplate(templateHash, revision, options) {
        return exports.TemplatesApiFp(this.configuration).deleteTemplate(templateHash, revision, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolve multiple i4.0 References at once with the backend. The result will be in the same order as supplied in the request body.
     * @param {Array<Reference>} reference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    resolveReferences(reference, options) {
        return exports.TemplatesApiFp(this.configuration).resolveReferences(reference, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the processing state of uploaded templates (descending order w.r.t. uploadedOn).
     * @param {string} [userId] Get template processing states for userId
     * @param {number} [limit] Retrieve only the last X states
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    retrieveAllProcessingStates(userId, limit, options) {
        return exports.TemplatesApiFp(this.configuration).retrieveAllProcessingStates(userId, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the I4.0 AAS template with the given hash
     * @param {string} templateHash
     * @param {string} [revision]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    retrieveTemplate(templateHash, revision, options) {
        return exports.TemplatesApiFp(this.configuration).retrieveTemplate(templateHash, revision, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves all submodels for a given I4.0 AAS template.
     * @param {string} templateHash
     * @param {string} [revision]
     * @param {string} [submodelIdShort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    retrieveTemplateSubmodels(templateHash, revision, submodelIdShort, options) {
        return exports.TemplatesApiFp(this.configuration).retrieveTemplateSubmodels(templateHash, revision, submodelIdShort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update template and/or the metadata for the given hash.
     * @param {string} templateHash
     * @param {string} revision Revision of the new template file
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    updateTemplateFile(templateHash, revision, file, options) {
        return exports.TemplatesApiFp(this.configuration).updateTemplateFile(templateHash, revision, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update template and/or the metadata for the given hash.
     * @param {string} templateHash
     * @param {TemplateMetadataUpdate} [metadata]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    updateTemplateMetadata(templateHash, metadata, options) {
        return exports.TemplatesApiFp(this.configuration).updateTemplateMetadata(templateHash, metadata, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload a new template along with its metadata.
     * @param {TemplateMetadata} metadata
     * @param {string} revision Revision of the template
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    uploadNewTemplateAndMetadata(metadata, revision, file, options) {
        return exports.TemplatesApiFp(this.configuration).uploadNewTemplateAndMetadata(metadata, revision, file, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TemplatesApi = TemplatesApi;
//# sourceMappingURL=templates-api.js.map